export default class MobileMenu {
  private readonly wrapper: HTMLElement;
  private readonly target?: HTMLElement;
  private readonly toggleClass?: string;

  constructor(element: HTMLElement) {
    this.wrapper = element;
    const targetSelector = this.wrapper.getAttribute('data-target');
    if (targetSelector) {
      const target = document.querySelector(targetSelector);
      if (target instanceof HTMLElement) {
        this.target = target;
      }
    }

    const toggleClass = this.wrapper.getAttribute('data-toggle');
    if (toggleClass) {
      this.toggleClass = toggleClass;
    }

    if (!this.target || !this.toggleClass) {
      return;
    }

    this.wrapper.addEventListener('click', e => this.toggleHandler(e), false);
  }

  toggleHandler(_e: Event): void {
    if (this.target && this.toggleClass) {
      this.target.classList.toggle(this.toggleClass);
    }
  }
}
